const dropdownOption = {
    valoansOptions: [
      {
        url: process.env.REACT_APP_FHA_PRODUCTS,
        name: "FHA",
      },
      {
        url: process.env.REACT_APP_USDA_PRODUCTS,
        name: "USDA",
      },
      {
        url: process.env.REACT_APP_CONV_PRODUCTS,
        name: "Conv",
      },
      {
        url: process.env.REACT_APP_HECM_PRODUCTS,
        name: "HECM",
      },
      {
        url: process.env.REACT_APP_FHA203K_PRODUCTS,
        name: "FHA 203(K)",
      },
      {
        url: process.env.REACT_APP_NON_QM_PRODUCTS,
        name: "NON-QM",
         }
    ],
    fhaloansOptions: [
      {
        url: process.env.REACT_APP_VA_PRODUCTS,
        name: "VA",
      },
      {
        url: process.env.REACT_APP_USDA_PRODUCTS,
        name: "USDA",
      },
      {
        url: process.env.REACT_APP_CONV_PRODUCTS,
        name: "Conv",
      },
      {
        url: process.env.REACT_APP_HECM_PRODUCTS,
        name: "HECM",
      },
      {
        url: process.env.REACT_APP_FHA203K_PRODUCTS,
        name: "FHA 203(K)",
      },
      {
        url: process.env.REACT_APP_NON_QM_PRODUCTS,
        name: "NON-QM",
         }
    ],
    usdaloansOptions: [
      {
        url: process.env.REACT_APP_FHA_PRODUCTS,
        name: "FHA",
      },
      {
        url: process.env.REACT_APP_VA_PRODUCTS,
        name: "VA",
      },
      {
        url: process.env.REACT_APP_CONV_PRODUCTS,
        name: "Conv",
      },
      {
        url: process.env.REACT_APP_HECM_PRODUCTS,
        name: "HECM",
      },
      {
        url: process.env.REACT_APP_FHA203K_PRODUCTS,
        name: "FHA 203(K)",
      },
      {
        url: process.env.REACT_APP_NON_QM_PRODUCTS,
        name: "NON-QM",
      }
    ],
    conventionalloansOptions: [
      {
        url: process.env.REACT_APP_FHA_PRODUCTS,
        name: "FHA",
      },
      {
        url: process.env.REACT_APP_VA_PRODUCTS,
        name: "VA",
      },
      {
        url: process.env.REACT_APP_USDA_PRODUCTS,
        name: "USDA",
      },
      {
        url: process.env.REACT_APP_HECM_PRODUCTS,
        name: "HECM",
      },
      {
        url: process.env.REACT_APP_FHA203K_PRODUCTS,
        name: "FHA 203(K)",
      },
      {
        url: process.env.REACT_APP_NON_QM_PRODUCTS,
        name: "NON-QM",
      }
    ],
    HECMloansOptions: [
      {
        url: process.env.REACT_APP_FHA_PRODUCTS,
        name: "FHA",
      },
      {
        url: process.env.REACT_APP_VA_PRODUCTS,
        name: "VA",
      },
      {
        url: process.env.REACT_APP_USDA_PRODUCTS,
        name: "USDA",
      },
      {
        url: process.env.REACT_APP_CONV_PRODUCTS,
        name: "Conv",
      },
      {
        url: process.env.REACT_APP_FHA203K_PRODUCTS,
        name: "FHA 203(K)",
      },
      {
        url: process.env.REACT_APP_NON_QM_PRODUCTS,
        name: "NON-QM",
      }
    ],
    "non-qmloansOptions": [
      {
        url: process.env.REACT_APP_FHA_PRODUCTS,
        name: "FHA",
      },
      {
        url: process.env.REACT_APP_VA_PRODUCTS,
        name: "VA",
      },
      {
        url: process.env.REACT_APP_USDA_PRODUCTS,
        name: "USDA",
      },
      {
        url: process.env.REACT_APP_CONV_PRODUCTS,
        name: "Conv",
      },
      {
        url: process.env.REACT_APP_HECM_PRODUCTS,
        name: "HECM",
      },
      {
        url: process.env.REACT_APP_FHA203K_PRODUCTS,
        name: "FHA 203(K)",
      },
      {
        url: process.env.REACT_APP_CHENOA_PRODUCTS,
        name: "Chenoa Fund DPA",
      }
    ],
    nonconformingloansOptions: [
      {
        url: process.env.REACT_APP_FHA_PRODUCTS,
        name: "FHA",
      },
      {
        url: process.env.REACT_APP_VA_PRODUCTS,
        name: "VA",
      },
      {
        url: process.env.REACT_APP_USDA_PRODUCTS,
        name: "USDA",
      },
      {
        url: process.env.REACT_APP_CONV_PRODUCTS,
        name: "Conv",
      },
      {
        url: process.env.REACT_APP_HECM_PRODUCTS,
        name: "HECM",
      },
      {
        url: process.env.REACT_APP_FHA203K_PRODUCTS,
        name: "FHA 203(K)",
      },
      {
        url: process.env.REACT_APP_NON_QM_PRODUCTS,
        name: "NON-QM",
      },
      {
        url: process.env.REACT_APP_CHENOA_PRODUCTS,
        name: "Chenoa Fund DPA",
      }
    ],
    dscrloansOptions: [
      {
        url: process.env.REACT_APP_FHA_PRODUCTS,
        name: "FHA",
      },
      {
        url: process.env.REACT_APP_VA_PRODUCTS,
        name: "VA",
      },
      {
        url: process.env.REACT_APP_USDA_PRODUCTS,
        name: "USDA",
      },
      {
        url: process.env.REACT_APP_CONV_PRODUCTS,
        name: "Conv",
      },
      {
        url: process.env.REACT_APP_HECM_PRODUCTS,
        name: "HECM",
      },
      {
        url: process.env.REACT_APP_FHA203K_PRODUCTS,
        name: "FHA 203(K)",
      },
      {
        url: process.env.REACT_APP_NON_QM_PRODUCTS,
        name: "NON-QM",
      },
      {
        url: process.env.REACT_APP_CHENOA_PRODUCTS,
        name: "Chenoa Fund DPA",
      }
    ],
    foreignnationalOptions: [
      {
        url: process.env.REACT_APP_FHA_PRODUCTS,
        name: "FHA",
      },
      {
        url: process.env.REACT_APP_VA_PRODUCTS,
        name: "VA",
      },
      {
        url: process.env.REACT_APP_USDA_PRODUCTS,
        name: "USDA",
      },
      {
        url: process.env.REACT_APP_CONV_PRODUCTS,
        name: "Conv",
      },
      {
        url: process.env.REACT_APP_HECM_PRODUCTS,
        name: "HECM",
      },
      {
        url: process.env.REACT_APP_FHA203K_PRODUCTS,
        name: "FHA 203(K)",
      },
      {
        url: process.env.REACT_APP_NON_QM_PRODUCTS,
        name: "NON-QM",
      },
      {
        url: process.env.REACT_APP_CHENOA_PRODUCTS,
        name: "Chenoa Fund DPA",
      }
    ],
    fha203kloansOptions: [
      {
        url: process.env.REACT_APP_FHA_PRODUCTS,
        name: "FHA",
      },
      {
        url: process.env.REACT_APP_VA_PRODUCTS,
        name: "VA",
      },
      {
        url: process.env.REACT_APP_USDA_PRODUCTS,
        name: "USDA",
      },
      {
        url: process.env.REACT_APP_CONV_PRODUCTS,
        name: "Conv",
      },
      {
        url: process.env.REACT_APP_HECM_PRODUCTS,
        name: "HECM",
      },
      {
        url: process.env.REACT_APP_NON_QM_PRODUCTS,
        name: "NON-QM",
      }
    ],
    chenoaprogramOptions: [
      {
        url: process.env.REACT_APP_FHA_PRODUCTS,
        name: "FHA",
      },
      {
        url: process.env.REACT_APP_VA_PRODUCTS,
        name: "VA",
      },
      {
        url: process.env.REACT_APP_USDA_PRODUCTS,
        name: "USDA",
      },
      {
        url: process.env.REACT_APP_CONV_PRODUCTS,
        name: "Conv",
      },
      {
        url: process.env.REACT_APP_HECM_PRODUCTS,
        name: "HECM",
      },
      {
        url: process.env.REACT_APP_NON_QM_PRODUCTS,
        name: "NON-QM",
      },
      {
        url: process.env.REACT_APP_FHA203K_PRODUCTS,
        name: "FHA 203(K)",
      },
    ]
  };
  
  export default dropdownOption;
  